import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// ⚠️ IMPORTANTE: estas son credenciales de EJEMPLO.
// Debes reemplazarlas por las de TU PROPIO proyecto de Firebase
// (sigue el PASO 2 de la guía GUIA_PUBLICAR.md — es gratis y toma 5 minutos).
// Si usas el proyecto de tu amiga, tus rifas y compras se guardarían en SU base de datos, no en la tuya.
const firebaseConfig = {
  apiKey: "AIzaSyBlYez9HzmyW7auXqagvhuM-0e6Rh1vss8",
  authDomain: "winnersrd-54d50.firebaseapp.com",
  projectId: "winnersrd-54d50",
  storageBucket: "winnersrd-54d50.firebasestorage.app",
  messagingSenderId: "706616586765",
  appId: "1:706616586765:web:31e5262ddf75941b3cdb44"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
